import { getColumnistInfoUrl, getColumnistInfoUrlNew } from './urls'
import fetch from '@/utils/fetch'

export function getColumnistInfo(uuid: string, ticket: string) {
  return fetch.get(getColumnistInfoUrl, {
    params: {
      uuid,
      ticket,
    },
  })
}

export function getColumnistInfoNum(uuid: string, ticket: string) {
  return fetch.get(getColumnistInfoUrlNew, {
    params: {
      uuid,
      ticket,
    },
  })
}
